import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { endpoints as catalogEndpoints } from './catalog/endpoints';
import { tags as categoriesTags } from './catalog/tags';
import { endpoints as productsEndpoints } from './products/endpoints';
import { tags as productsTags } from './products/tags';
import { endpoints as searchEndpoints } from './search/endpoints';

const params = Object.fromEntries((new URLSearchParams(window.location.search)).entries());

export const hotracoApi = {};
Object.assign(hotracoApi, createApi({
  reducerPath: 'hotracoApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${window.location.protocol}//${window.location.hostname}`,
    prepareHeaders: (headers) => {
      headers.set('accept', 'application/json');
      if (params.token) {
        headers.set('X-Craft-Token', params.token);
      }
      return headers;
    },
  }),
  tagTypes: [
    ...categoriesTags,
    ...productsTags,
  ],
  endpoints: (builder) => ({
    ...catalogEndpoints(builder),
    ...productsEndpoints(builder),
    ...searchEndpoints(builder),
  }),
}));

export const {
  util,
  useGetProductReleaseFeaturesQuery,
  useGetProductInstructionVideosQuery,
  useGetProductOnlineCoursesQuery,
  useGetProductDocumentationQuery,
  useGetProductModulesAndPartsQuery,
  useGetProductMarketingItemsQuery,
  useGetRelatedProductsQuery,
  useGetProductCategoriesQuery,
  useGetCatalogTranslatesQuery,
  useGetSearchTranslatesQuery,
} = hotracoApi;
